module.exports = [
  require('./tanarukk'),
  require('./thorny'),
  require('./tlincalli'),
  require('./transmuter'),
  require('./trapper'),
]
